// removed by extract-text-webpack-plugin
module.exports = {"floating-container":"r163czrY9lcc8OYENmN0x","floatingContainer":"r163czrY9lcc8OYENmN0x","spin":"x-3X2AR6ylFBnOtid9VB_","slide-in":"_298zzvRqmL-mQoXf6dmdUV","slideIn":"_298zzvRqmL-mQoXf6dmdUV"};


//////////////////
// WEBPACK FOOTER
// ./src/vendor/react-store/components/View/FloatingContainer/styles.scss
// module id = 235
// module chunks = 8